import { mapActions, mapGetters, mapMutations } from "vuex";

import FacebookWidget from "@/components/widgets/facebook/index.vue";
import GoogleWidget from "@/components/widgets/google/index.vue";
import AppleWidget from "@/components/widgets/apple/index.vue";

import { email, maxLength, minLength, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { emailFormatter } from "@/mixins/validation";
import { translationUtils } from "@/utils/translations";

export default {
	name        : "sing-in",
	mixin       : [validationMixin],
	data() {
		return {
			payload: {
				login	: "",
				password: "",
			},
			showPassword	: false,
			validationErrors: {},
		};
	},
	components  : {
		FacebookWidget,
		GoogleWidget,
		AppleWidget,
	},
	validations : {
		payload	: {
			password: {
				required,
				minLength	: minLength(10),
				maxLength	: maxLength(50),
			},
			login	: {
				required,
				email		: (val) => email(emailFormatter(val)),
				maxLength	: maxLength(50),
			},
		},
	},
	computed    : {
		...mapGetters({
			config			: "setting/config",
			loadingSingIn	: "auth/loadingSingIn",
			loadingUser		: "user/loadingUser",
			user			: "user/user",
		}),
		disableButton() {
			if (this.payload.password === "" || this.payload.login === "") {
				return true;
			} else {
				return false;
			}
		},
		passwordErrors() {
			let error = [];
			if (!this.$v.payload.password.$dirty) {
				return error;
			}
			if (!this.$v.payload.password.required) {
				error.push(this.$t("validationRequired"));
			}
			if (!this.$v.payload.password.minLength) {
				error.push(
					this.$t("minLengthField")
						.replace(":field", this.$t("passwordField"))
						.replace(":count", 10)
				);
			}
			if (!this.$v.payload.password.maxLength) {
				error.push(
					this.$t("maxLengthField")
						.replace(":field", this.$t("passwordField"))
						.replace(":count", 50)
				);
			}
			if (this.validationErrors.password) {
				this.validationErrors.password.forEach((row) => {
					error.push(row);
				});
			}
			return error;
		},
		emailErrors() {
			let error = [];
			if (!this.$v.payload.login.$dirty) {
				return error;
			}
			if (!this.$v.payload.login.required) {
				error.push(this.$t("validationRequired"));
			}
			if (!this.$v.payload.login.maxLength) {
				error.push(
					this.$t("maxLengthField")
						.replace(":field", this.$t("emailFieldShort"))
						.replace(":count", 50)
				);
			}
			if (!this.$v.payload.login.email) {
				error.push(this.$t("validationEmail"));
			}
			if (this.validationErrors.login) {
				this.validationErrors.login.forEach((row) => {
					error.push(row);
				});
			}
			return error;
		},
	},
	methods     : {
		...mapActions({
			singIn		: `auth/AUTH_LOGIN`,
			attachTest	: `tests/ATTACH_TESTS`,
			fetchUser	: `user/GET_USER_DATA`,
		}),
		...mapMutations({
			changePopupRestorePasswordEmail: `auth/AUTH_SHOW_POPUP_RESTORE_PASSWORD`,
		}),
		getConfigItem(key) {
			for (let i in this.config) {
				if (this.config[i].key === key) {
					return this.config[i];
				}
			}
		},
		submit() {
			if(this.loadingSingIn || this.loadingUser){
				return;
			}
			
			this.$v.$touch();
			
			if (!this.$v.$invalid) {
				this.singIn(this.payload)
					.then(() => {
						//this.$toasted.success(this.$t("successAuth"));
						
						this.fetchUser()
						.then(() => {
							var userLang = '';
							
							if (this.user.languageInterface.value) {
								userLang = this.user.languageInterface.value;
							} else {
								userLang = (this.user.languageInterface.value = "en");
							}
							
							translationUtils.setInterfaceLanguage(userLang);
							
							this.$toasted.success(this.$t("successAuth"));
							
							const redirect = this.$route.query.redirect || `/${userLang}/courses`;
							
							this.$router.push(redirect);
							
							// window.location.href = "/" + userLang + "/courses";
						})
						.catch((error) => {
							this.$toasted.error(error.response.data.message);
						});
						
						// check completed test when user non auth
						if (localStorage.getItem("hasUserCompletedTestsWhenIsNonAuth")) {
							this.attachTest()
								.then(() => {
									localStorage.removeItem(
										"hasUserCompletedTestsWhenIsNonAuth"
									);
								})
								.catch((error) => {
									this.$toasted.error(error.response.data.message);
								});
						}
					})
					.catch((error) => {
						this.$toasted.error(error.response.data.message);
					});
			}
		},
	},
};
